/** Production site origin; override via `window._env_.REACT_APP_SITE_URL` (see `public/env-config.js`). */
export function getSiteUrl(): string {
  const w = window as Window & { _env_?: { REACT_APP_SITE_URL?: string } };
  const fromEnv = w._env_?.REACT_APP_SITE_URL?.trim();
  if (fromEnv?.startsWith('http')) {
    return fromEnv.replace(/\/$/, '');
  }
  return 'https://ayletaib.com';
}
